import React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import Group from 'sail/Group';
import {Intro, CaptionAlt, Heading} from 'sail/Text';
import {defineMessages, FormattedMessage} from 'react-intl';
import {useGuide} from '../../data/GuideProvider';
import {ElementsEditor} from './ElementsEditor';
import {FormattedMessageOrString} from '../../../../data/localization/intlUtils';

import '../../css/Step.scss';

const messages = defineMessages({
  server: {
    id: 'docsApp.integrationBuilder.step.server',
    description: 'Server label',
    defaultMessage: 'Server',
  },
  client: {
    id: 'docsApp.integrationBuilder.step.client',
    description: 'Client label',
    defaultMessage: 'Client',
  },
});

export default function Step({step, index, hidden}) {
  const {activeStep, scrollToStep, setActiveStepById, fireEvent} = useGuide();
  const isActive = activeStep && activeStep.id === step.id;
  const classes = classNames(
    'Step',
    isActive && 'Step--active',
    !hidden && 'Step--visible',
  );

  const stepLabel = () => {
    if (!step.testing) {
      return {
        labelClassName: step.server
          ? 'Step-label--server'
          : 'Step-label--client',
        label: step.server ? messages.server : messages.client,
      };
    }
    return {};
  };

  const handleStepSelection = (evt) => {
    fireEvent('click_step', {
      step_id: step.id,
    });

    const stepEl = document.querySelector(`.Step[data-id="${step.id}"]`);

    // Scroll to the step if our selected step is partial out of the viewport
    // Otherwise set the step as active without scrolling
    if (
      (stepEl && stepEl.getBoundingClientRect().bottom > window.innerHeight) ||
      stepEl.getBoundingClientRect().top < 0
    ) {
      scrollToStep(step.id);
    } else {
      setActiveStepById(step.id);
    }
  };

  const {label, labelClassName} = stepLabel();
  return (
    <Box
      className={classes}
      data-id={step.id}
      data-section={step.section}
      data-index={step.index}
      key={`Step-${index}`}
      margin={{top: 24}}
      onClick={handleStepSelection}
      tabIndex={hidden ? -1 : 0}
    >
      <Box padding={{horizontal: 24, vertical: 20}} className="Step-border">
        <Group spacing={{vertical: 8}}>
          <Heading style={{fontWeight: 600}}>
            <FormattedMessageOrString stringOrDefineMessage={step.heading} />
          </Heading>
          <Intro className="description">
            <FormattedMessageOrString stringOrDefineMessage={step.body} />
          </Intro>
          {/* TODO(mfix) refactor to use common Component interface */}
          {step.Component && <step.Component />}
          {step.tabs && step.tabs.type === 'editor' && (
            <ElementsEditor
              step={step}
              tabs={step.tabs.options}
              active={step.tabs.active}
            />
          )}
          {label && (
            <Box flex={{alignItems: 'center'}}>
              <Box className={classNames('Step-label', labelClassName)} />
              <Box>
                <CaptionAlt color="gray">
                  {<FormattedMessage {...label} />}
                </CaptionAlt>
              </Box>
            </Box>
          )}
        </Group>
      </Box>
    </Box>
  );
}
